import * as React from 'react';
import { SVGProps } from 'react';

const IconInComparisonSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h2v14H1V1zm6 2.95 1.414-1.414 2.122 2.12 3.535-3.535 1.414 1.415-4.95 4.95L7 3.95zM7 6H5v9h2V6zm2 3h2v6H9V9zm6 1h-2v5h2v-5z" />
  </svg>
);
export default IconInComparisonSizeS;
